'use client'

import { X } from 'lucide-react'
import { useState } from 'react'

const DeliveryNotAvailable = () => {
  const [show, setShow] = useState(true)

  if (!show) return null

  return (
    <div className='delivery-not-available'>
      <div className='close' onClick={() => setShow(false)}><X /></div>
      <p>Lo sentimos, no estamos aceptando pedidos en este momento. Prueba de nuevo más tarde.</p>
    </div>
  )
}
export default DeliveryNotAvailable
